module.exports = __webpack_public_path__ + "static/img/3.f7bc78d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pczhongfu/3.png
// module id = /w/7
// module chunks = 0